var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "MeterConsumption",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: { name: _vm.formName, id: _vm.formId },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "consumer",
                        label: _vm._f("pgettext")("Meter", "MeterConsumption"),
                        helpTooltip: _vm._f("pgettext")(
                          "The consuming meter",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        required: "",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("UcMeterSelector", {
                        attrs: {
                          item: _vm.item,
                          path: "meter",
                          readonly: _vm.isReadOnly,
                          required: ""
                        },
                        on: {
                          optionSelected: function($event) {
                            return _vm.evh_7789867021953041_optionSelected(
                              $event,
                              {}
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "consumer",
                        label: _vm._f("pgettext")(
                          "Consumer",
                          "MeterConsumption"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "The consumer of the resources",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        required: "",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("UcCompanySelector", {
                        attrs: {
                          item: _vm.item,
                          path: "consumer",
                          readonly: _vm.isReadOnly,
                          required: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "unit",
                        label: _vm._f("pgettext")("Unit", "MeterConsumption"),
                        helpTooltip: _vm._f("pgettext")(
                          "Unit of measurement",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "3",
                        labelAlign: _vm.labelAlign,
                        required: ""
                      }
                    },
                    [
                      _c("ItpFormSelect2", {
                        attrs: {
                          name: "unit",
                          options: _vm.units,
                          valueField: "symbol",
                          textField: "symbol",
                          readonly: _vm.isReadOnly,
                          required: ""
                        },
                        model: {
                          value: _vm.item.unit,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "unit", $$v)
                          },
                          expression: "item.unit"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "start",
                        label: _vm._f("pgettext")("Start", "MeterConsumption"),
                        helpTooltip: _vm._f("pgettext")(
                          "Start reading and it's date",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "form-row",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("ItpFormInput", {
                            attrs: {
                              type: "number",
                              name: "start_reading",
                              placeholder: _vm._f("pgettext")(
                                "Start reading",
                                "MeterConsumption|InputPlaceholder"
                              ),
                              readonly: _vm.isReadOnly
                            },
                            model: {
                              value: _vm.item.start.reading,
                              callback: function($$v) {
                                _vm.$set(_vm.item.start, "reading", $$v)
                              },
                              expression: "item.start.reading"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("ItpFormDatetime", {
                            attrs: {
                              type: "date",
                              name: "start_date",
                              placeholder: _vm._f("pgettext")(
                                "Start date",
                                "MeterConsumption|InputPlaceholder"
                              ),
                              readonly: _vm.isReadOnly
                            },
                            model: {
                              value: _vm.item.start.date,
                              callback: function($$v) {
                                _vm.$set(_vm.item.start, "date", $$v)
                              },
                              expression: "item.start.date"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "end",
                        label: _vm._f("pgettext")("End", "MeterConsumption"),
                        helpTooltip: _vm._f("pgettext")(
                          "End reading and it's date",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "form-row",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("ItpFormInput", {
                            attrs: {
                              type: "number",
                              name: "end_reading",
                              placeholder: _vm._f("pgettext")(
                                "End reading",
                                "MeterConsumption|InputPlaceholder"
                              ),
                              readonly: _vm.isReadOnly
                            },
                            model: {
                              value: _vm.item.end.reading,
                              callback: function($$v) {
                                _vm.$set(_vm.item.end, "reading", $$v)
                              },
                              expression: "item.end.reading"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("ItpFormDatetime", {
                            attrs: {
                              type: "date",
                              name: "end_date",
                              placeholder: _vm._f("pgettext")(
                                "End date",
                                "MeterConsumption|InputPlaceholder"
                              ),
                              readonly: _vm.isReadOnly
                            },
                            model: {
                              value: _vm.item.end.date,
                              callback: function($$v) {
                                _vm.$set(_vm.item.end, "date", $$v)
                              },
                              expression: "item.end.date"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "rental",
                        label: _vm._f("pgettext")("Rental", "MeterConsumption"),
                        helpTooltip: _vm._f("pgettext")(
                          "The rental the consumption belongs to",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormSelect2", {
                        attrs: {
                          name: "rental",
                          dataSource: _vm.b_4152404563918957_dataSource,
                          valueField: "id",
                          textField: "name",
                          "bind-object": "",
                          clearable: "",
                          "use-option-template-for-selected-option": "",
                          optionTemplate:
                            '<UcSuggestRentalOption :option="option"></UcSuggestRentalOption>'
                        },
                        model: {
                          value: _vm.item.rental,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "rental", $$v)
                          },
                          expression: "item.rental"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "non_billable",
                        label: _vm._f("pgettext")(
                          "Non billable",
                          "MeterConsumption"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Optional flag to exclude this consumption from billing processes",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormCheckbox", {
                        attrs: {
                          name: "non_billable",
                          inline: "",
                          readonly: _vm.isReadOnly
                        },
                        model: {
                          value: _vm.item.non_billable,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "non_billable", $$v)
                          },
                          expression: "item.non_billable"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "billing_factor",
                        label: _vm._f("pgettext")(
                          "Billing factor",
                          "MeterConsumption"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Optional multiplier applied to consumption",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          type: "number",
                          name: "billing_factor",
                          readonly: _vm.isReadOnly
                        },
                        model: {
                          value: _vm.item.billing_factor,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "billing_factor", $$v)
                          },
                          expression: "item.billing_factor"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "tariff",
                        label: _vm._f("pgettext")(
                          "Billing tariff",
                          "MeterConsumption"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Tariff plan to use for billing",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormSelect2", {
                        attrs: {
                          name: "tariff",
                          options: _vm.tariffs,
                          valueField: "id",
                          textField: "name",
                          readonly: _vm.isReadOnly
                        },
                        model: {
                          value: _vm.item.tariff,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "tariff", $$v)
                          },
                          expression: "item.tariff"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.item.unit_price
                    ? _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "unit_price",
                            label: _vm._f("pgettext")(
                              "Unit price",
                              "MeterConsumption"
                            ),
                            helpTooltip: _vm._f("pgettext")(
                              "Price per unit for billing",
                              "MeterConsumption"
                            ),
                            labelColsMd: "4",
                            contentColsMd: "8",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group"
                          }
                        },
                        [
                          _c("ItpFormInput", {
                            staticClass: "col-8",
                            attrs: {
                              placeholder: _vm._f("pgettext")(
                                "Amount",
                                "MeterConsumption|InputPlaceholder"
                              ),
                              type: "number",
                              name: "unit_price_amount"
                            },
                            model: {
                              value: _vm.item.unit_price.amount,
                              callback: function($$v) {
                                _vm.$set(_vm.item.unit_price, "amount", $$v)
                              },
                              expression: "item.unit_price.amount"
                            }
                          }),
                          _vm._v(" "),
                          _c("ItpFormSelect", {
                            staticClass: "col-4",
                            attrs: {
                              placeholder: _vm._f("pgettext")(
                                "Currency",
                                "MeterConsumption|InputPlaceholder"
                              ),
                              name: "currency",
                              options: _vm.currencies,
                              textField: "code",
                              valueField: "code",
                              required: "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.item.unit_price.currency,
                              callback: function($$v) {
                                _vm.$set(_vm.item.unit_price, "currency", $$v)
                              },
                              expression: "item.unit_price.currency"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "note",
                        label: _vm._f("pgettext")("Note", "MeterConsumption"),
                        helpTooltip: _vm._f("pgettext")(
                          "Optional note or comment about this meter period",
                          "MeterConsumption"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormTextarea", {
                        attrs: { name: "note", readonly: _vm.isReadOnly },
                        model: {
                          value: _vm.item.note,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "note", $$v)
                          },
                          expression: "item.note"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _vm.oid && !_vm.item.locked
                ? _c(
                    "ItpBox",
                    { staticClass: "mr-auto" },
                    [
                      _c("BtnDeleteResource", {
                        attrs: {
                          resource: _vm.item,
                          disabled: _vm.actions.submit.isRunning,
                          tabindex: "-1"
                        },
                        on: {
                          success: function($event) {
                            return _vm.evh_2140198529698299_success($event, {})
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BtnLockResource", {
                        staticClass: "ml-3",
                        attrs: {
                          resource: _vm.item,
                          disabled: _vm.actions.submit.isRunning,
                          tabindex: "-1"
                        },
                        on: {
                          success: function($event) {
                            return _vm.evh_2434514588044777_success($event, {})
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.item.locked
                ? _c("ItpButton", {
                    attrs: {
                      text: _vm._f("pgettext")("Save", "ModalButton"),
                      type: "submit",
                      form: _vm.formId,
                      variant: "primary",
                      icon: "fa-save",
                      spinning: _vm.actions.submit.isRunning,
                      disabled:
                        !_vm.forms[_vm.formName] ||
                        !_vm.forms[_vm.formName].submittable
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "ModalButton"),
                  variant: "default",
                  disabled: _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_2186679009640457_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }